export const valueProposition = {
  title: "Por que escolher Gándara?",
  subtitle: "Três pilares fundamentais que definem nossa proposta educacional",
  items: {
    montessori: {
      title: "Pedagogia Ativa Montessori",
      description: "Ambientes preparados, materiais manipulativos e respeito pelos ritmos individuais de aprendizagem"
    },
    nature: {
      title: "Natureza e Espaços",
      description: "Mais de 5.000 m² de instalações com horta, áreas verdes e conexão constante com o ambiente natural"
    },
    community: {
      title: "Comunidade Educativa",
      description: "Turmas reduzidas (1:12) e acompanhamento próximo que permite atenção personalizada"
    }
  }
};
